export default __webpack_public_path__ + "static/media/6.a8a99557.jpg";